import React from 'react';
import { servicesData } from './ServicesData';
import { ChevronRight, ArrowUpRight } from 'lucide-react';

const COLORS = {
  bgPrimary: "#080C10",   // Darker Onyx
  bgSecondary: "rgba(255, 255, 255, 0.03)", // Glass effect
  gold: "#C8A27C",        // Muted Champagne Gold
  textLight: "#F5F5F5",
};

const ServicesList = () => {
  return (
    <section className="py-32 px-6 md:px-12 relative overflow-hidden" style={{ backgroundColor: COLORS.bgPrimary }}>
      
      {/* BACKGROUND DECORATION */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#C8A27C]/5 to-transparent pointer-events-none" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        
        {/* SECTION HEADER */}
        <div className="mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-[1px] w-12 bg-[#C8A27C]"></span>
              <span style={{ color: COLORS.gold }} className="uppercase tracking-[0.5em] text-[10px] font-black">
                Areas of Expertise
              </span>
            </div>
            <h2 className="text-6xl md:text-8xl text-white font-serif leading-[0.9] tracking-tighter">
              Legal <br />
              <span className="italic font-light opacity-40 text-[#C8A27C]">Excellence.</span>
            </h2>
          </div>
          <p className="text-gray-500 max-w-xs text-sm leading-relaxed border-l border-white/10 pl-6 mb-4">
            Providing sophisticated legal strategies and tenacious representation across Northern India.
          </p>
        </div>

        {/* SERVICES GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-[2rem] overflow-hidden">
          {servicesData.map((service) => (
            <div 
              key={service.id} 
              className="group relative p-12 bg-[#080C10] transition-all duration-700 hover:bg-[#0D141C] flex flex-col justify-between min-h-[450px]"
            >
              {/* CONTENT AREA */}
              <div className="relative z-10">
                {/* ID Indicator */}
                <div className="text-[10px] font-black tracking-widest text-white/20 mb-12 flex items-center gap-2">
                  <span className="w-6 h-[1px] bg-white/20"></span>
                  0{service.id}
                </div>

                {/* Icon with Ring */}
                <div className="relative w-16 h-16 mb-10 flex items-center justify-center rounded-2xl bg-white/5 border border-white/10 group-hover:border-[#C8A27C]/50 group-hover:bg-[#C8A27C]/10 transition-all duration-500">
                  <div className="text-4xl transform transition-transform duration-700 group-hover:scale-110 group-hover:-rotate-12">
                    {service.icon}
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-white text-3xl font-serif mb-6 group-hover:text-[#C8A27C] transition-colors duration-500">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-500 text-base leading-relaxed mb-10 font-light group-hover:text-gray-300 transition-colors line-clamp-3">
                  {service.shortDesc}
                </p>
              </div>

              {/* ACTION LINK */}
              <a 
                href={`/services/${service.id}`}
                className="relative z-10 inline-flex items-center gap-4 text-[11px] font-black uppercase tracking-[0.3em] transition-all"
                style={{ color: COLORS.gold }}
              >
                <span>Case Analysis</span>
                <div className="w-10 h-10 rounded-full border border-[#C8A27C]/20 flex items-center justify-center group-hover:bg-[#C8A27C] group-hover:text-[#080C10] transition-all duration-500">
                  <ArrowUpRight size={14} />
                </div>
              </a>

              {/* OVERLAY DECOR */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#C8A27C]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesList;